export default __webpack_public_path__ + "static/media/030-water well.266d39b4.svg";